import { Badge } from "@/components/ui/badge";
import { Sparkles, AlertTriangle, Mountain, MapPin, Eye, Landmark } from "lucide-react";

interface AIWaypointBadgeProps {
  detectionType: string;
  autoGenerated?: boolean;
}

const AIWaypointBadge = ({ detectionType, autoGenerated }: AIWaypointBadgeProps) => {
  if (!autoGenerated) return null;

  const getIcon = () => {
    switch (detectionType) {
      case 'obstacle':
        return <AlertTriangle className="h-3 w-3" />;
      case 'scenic':
        return <Eye className="h-3 w-3" />;
      case 'hazard':
        return <AlertTriangle className="h-3 w-3" />;
      case 'landmark':
        return <Landmark className="h-3 w-3" />;
      case 'poi':
        return <MapPin className="h-3 w-3" />;
      default:
        return <Sparkles className="h-3 w-3" />;
    }
  };

  const getLabel = () => {
    switch (detectionType) {
      case 'obstacle':
        return 'AI: Obstacle';
      case 'scenic':
        return 'AI: Scenic';
      case 'hazard':
        return 'AI: Hazard';
      case 'landmark':
        return 'AI: Landmark';
      case 'poi':
        return 'AI: Point of Interest';
      default:
        return 'AI Detected';
    }
  };

  const getVariant = () => {
    switch (detectionType) {
      case 'obstacle':
      case 'hazard':
        return 'destructive';
      case 'scenic':
        return 'secondary';
      default:
        return 'default';
    }
  };

  return (
    <Badge variant={getVariant() as any} className="gap-1">
      {getIcon()}
      {getLabel()}
    </Badge>
  );
};

export default AIWaypointBadge;
